import { useAuthStore } from "@/stores/auth.module";
import { computed } from "vue";

export function usePlannerPermissions() {
  const authStore = useAuthStore();

  const view = computed(() => {
    return (
      authStore.currentInstitution?.settings.planner.enabledEmployees || false
    );
  });

  return { view };
}
